import { Component, Input, OnChanges, Output, SimpleChanges, EventEmitter, ViewChild, OnInit, ElementRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';
import ExpandMenu from '../../../../assets/data/expanded-menu.json';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { LoaderFactory } from '@shared/factories/loader/loader.factory';
import { AfTranslateDirective } from '@shared/modules/translate/directive/af-translate.directive';
import { ApiServiceService } from '@shared/services/api-service/api-service.service';
import { ModalServiceService } from '@shared/services/modal-service/modal-service.service';
import { CustomizeFieldOtherComponent } from '../customize-field-other/customize-field-other.component';
import { CustomizeFieldFormulaComponent } from '../customize-field-formula/customize-field-formula.component';
import { CustomizeFieldBoolComponent } from '../customize-field-bool/customize-field-bool.component';
import { CustomizeFieldMoneyComponent } from '../customize-field-money/customize-field-money.component';
import { CustomizeFieldDateComponent } from '../customize-field-date/customize-field-date.component';
import { CustomizeFieldListComponent } from '../customize-field-list/customize-field-list.component';
import { CustomizeFieldNumComponent } from '../customize-field-num/customize-field-num.component';
import { CustomizeFieldTextComponent } from '../customize-field-text/customize-field-text.component';
import { FieldTypeTextSimpleComponent } from "../../../shared/components/field-type-text/field-type-text-simple/field-type-text-simple.component";
import { FieldTypeRichTextEditableComponent } from "../../../shared/components/field-type-rich-text/field-type-rich-text-editable/field-type-rich-text-editable.component";
import { FieldTypeListSimpleComponent } from "../../../shared/components/field-type-list/field-type-list-simple/field-type-list-simple.component";
import { SpanTooltipComponent } from "../../../shared/components/span-tooltip/span-tooltip.component";
import { ButtonWithMenuActionComponent } from "../../../shared/components/button-with-menu-action/button-with-menu-action.component";
import { VisibilityComponent } from "../../../shared/components/visibility/visibility.component";
import { CustomizeFieldsSwitchFormComponent } from "../customize-fields-switch-form/customize-fields-switch-form.component";
import { FieldTypeSwitchComponent } from "../../../shared/components/field-type-switch/field-type-switch.component";
import { CustomizeFieldsFactory } from '@shared/factories/customize-fields/customize-fields.factory';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { cloneDeep } from 'lodash';
import { AutoFocusModule } from 'primeng/autofocus';

@Component({
    selector: 'customize-fields',
    templateUrl: './customize-fields.component.html',
    standalone: true,
    imports: [NgClass, FormsModule, CustomizeFieldTextComponent, CustomizeFieldNumComponent, CustomizeFieldListComponent, CustomizeFieldDateComponent, CustomizeFieldMoneyComponent, CustomizeFieldBoolComponent, CustomizeFieldFormulaComponent, CustomizeFieldOtherComponent, FieldTypeTextSimpleComponent, FieldTypeRichTextEditableComponent, FieldTypeListSimpleComponent, SpanTooltipComponent, ButtonWithMenuActionComponent, AfTranslateDirective, VisibilityComponent, CustomizeFieldsSwitchFormComponent, FieldTypeSwitchComponent, DragDropModule, AutoFocusModule]
})
export class CustomizeFieldsComponent implements OnInit, OnChanges {
  customizeFields: any = {
    maxlengthInput: 150,
    formConfiguration: false,
    channelViewEditable: false,
    templatesList: [],
    reportList: this.customizeFieldsFactory.getReportList(),
    fieldOptions: { expandedMenu: cloneDeep(ExpandMenu['paramGroup'].menu) },
    titleField: { label: this.translate.instant('common.title') },
    descriptionField: {
      fieldTypeId: 'rich',
      isEditable: true,
      label: this.translate.instant('common.description')
    },
    fieldTemplates: {
      label: this.translate.instant('new-document.template'),
      noEditable: false,
      required: true,
      isOpen: true,
      type: 'customTemplate'
    },
    contentReportInfo: { label: this.translate.instant('common.report-field') },
    multipleField: { label: this.translate.instant('customize.multiple') },
    editableField: { label: this.translate.instant('customize.editable') }
  }
  constructor(
    private translate: AfTranslateFactory,
    private apiService: ApiServiceService,
    private loader: LoaderFactory,
    private modalService: ModalServiceService,
    private customizeFieldsFactory: CustomizeFieldsFactory,
    private commonUtilsService: CommonUtilsService
  ) { }

  @Input() field: any = null;
  @Input() actionType: string = 'edit';
  @Input() typeView: string = 'normal';
  @Input() previewMode: boolean = false;
  @Input() hiddenHeader: boolean = false;
  @Input() disabled: any = null;
  @Input() fieldContainer: any;
  @Input() isPrivate: any = null;
  @Input() hiddenInLandings: boolean = false;
  @Input() concept: any = {};
  @Input() visibilityItems: any = [];
  @Input() disabledFormTranslations: any = [];
  @Output() launchAction = new EventEmitter();
  @ViewChild(CustomizeFieldTextComponent) customizeFieldText: CustomizeFieldTextComponent;
  @ViewChild(CustomizeFieldMoneyComponent) customizeFieldMoney: CustomizeFieldMoneyComponent;
  @ViewChild(CustomizeFieldOtherComponent) customizeFieldOther: CustomizeFieldOtherComponent;
  @ViewChild(CustomizeFieldBoolComponent) customizeFieldBool: CustomizeFieldBoolComponent;
  @ViewChild(CustomizeFieldListComponent) customizeFieldList: CustomizeFieldListComponent;
  @ViewChild(CustomizeFieldFormulaComponent) customizeFieldFormula: CustomizeFieldFormulaComponent;
  @ViewChild('customizeFieldInput') customizeFieldInput: ElementRef;

  ngOnInit(): void {
    this.customizeFields.fieldOptions.expandedMenu[1].name = this.translate.instant('expanded-menu.delete-field');
    this.configureViewField();
  }

  ngOnChanges(changes: SimpleChanges): void {
    let that: any = this.customizeFields;
    that.templatesList = cloneDeep(this.concept.templatesConcept);
    that.channelViewEditable = this.typeView === 'channelView' && !this.previewMode;
    if(changes['field'] && changes['field'].currentValue){
      this.configureFields();
      that.field = changes['field'].currentValue;
      if (this.typeView !== 'translationsViewEditable') {
        that.field.editableName = that.channelViewEditable ? true : false;
      }
    }
    if (!this.disabledFormTranslations || !this.disabledFormTranslations.length) {
      this.disabledFormTranslations = [];
    }
    this.configureEditableFields();
    if (this.typeView === 'translationsViewNoEditable' || this.typeView == 'translationsViewEditable') {
      this.configureViewField();
    }
  }

  configureFields(){
    if((this.concept?.poll && this.concept?.disabled) || this.field.noEditable){
      this.customizeFields.contentReportInfo.noEditable = true;
    }
    if(this.actionType === 'create'){
      this.field.fieldAttributes = {};
      if(this.field.fieldTypeId === 'list' || this.field.fieldTypeId === 'listp'){
      this.field.listValues = [];
      }
    }
  }

  configureViewField(){
    let that: any = this.customizeFields;
    that.field.fieldTypeIdPainted = that.field.fieldTypeId;
    switch(that.field.fieldTypeId){
      case 'text':
        that.field.icon = 'lf-icon-text-field';
        break;
      case 'rich':
        that.field.icon = 'lf-icon-text-edit';
        break;
      case 'list':
        that.field.icon = 'lf-icon-dropdown';
        that.field.requiredFields = true;
        break;
      case 'listp':
        that.field.icon = 'lf-icon-dropdown-weight';
        that.field.fieldTypeIdPainted = 'list';
        that.field.requiredFields = true;
        break;
      case 'l-co':
        that.field.icon = 'lf-icon-connected-data';
        that.field.requiredFields = true;
        break;
      case 'num':
        that.field.icon = 'lf-icon-hashtag';
        break;
      case 'date':
        that.field.icon = 'lf-icon-calendar';
        break;
      case 'bool':
        that.field.icon = 'lf-icon-switch-right';
        break;
      case 'boolp':
        that.field.icon = 'lf-icon-switch-right-weight';
        that.field.fieldTypeIdPainted = 'bool';
        that.field.requiredFields = true;
        if(that.field?.listValues){
          that.field.weightYes = that.field?.listValues[0]?.weight;
          that.field.weightNo = that.field?.listValues[1]?.weight;
        }
        break;
      case 'formu':
        that.field.icon = 'lf-icon-calculator';
        that.field.requiredFields = true;
        break;
      case 'formp':
        that.field.icon = 'lf-icon-calculator-weight';
        that.field.fieldTypeIdPainted = 'formu';
        that.field.requiredFields = true;
        break;
      case 'file':
        that.field.icon = 'lf-icon-up-file';
        break;
      case 'money':
        that.field.icon = 'lf-icon-coin';
        that.field.requiredFields = true;
        break;
      case 'user':
        that.field.icon = 'lf-icon-user';
        break;
      case 'txchk':
        that.field.icon = 'lf-icon-check-empty';
        that.field.requiredFields = true;
        that.descriptionField.required = true;
        that.descriptionField.label = this.translate.instant('customize-field.text-description-check');
        break;
      case 'templ':
        that.field.icon = 'lf-icon-textbooks';
        that.field.requiredFields = true;
        that.descriptionField.label = this.translate.instant('field-list.introduction') + ' ' + this.translate.instant('field-list.button-generate-document')
        that.infoDescription = this.translate.instant('customize-field.description-template');
        break;
      case 'alert':
        that.field.icon = 'lf-icon-notification';
        that.descriptionField.label = this.translate.instant('field-list.introduction') + ' ' + this.translate.instant('field-list.button-create-alert')
        that.infoDescription = this.translate.instant('customize-field.description-alert');
        if(this.actionType === 'create' && this.concept?.allowPublicShare){
          that.field.private = true;
        }
        break;
      case 'task':
        that.field.icon = 'lf-icon-task';
        that.descriptionField.label = this.translate.instant('field-list.introduction') + ' ' + this.translate.instant('field-list.button-create-task')
        that.infoDescription = this.translate.instant('customize-field.description-task');
        if(this.actionType === 'create' && this.concept?.allowPublicShare){
          that.field.private = true;
        }
        break;
    }
  }

  configureEditableFields(){
    let that: any = this.customizeFields;
    if(this.actionType !== 'create' && this.typeView !== 'channelView' && this.concept.hasInstances && that.field.fieldTypeId !== 'bool' && that.field.fieldTypeId !== 'rich'){
      that.field.noEditable = true;
      that.field.disabled = true;
    }
    let fieldsDisabled: any = this.concept?.disabled || this.previewMode;
    that.titleField.noEditable = fieldsDisabled || this.disabledFormTranslations.includes('extendedLabel');
    that.descriptionField.noEditable = fieldsDisabled || this.disabledFormTranslations.includes('description');
    that.fieldTemplates.noEditable = fieldsDisabled;
    that.contentReportInfo.noEditable = that.field.noEditable || fieldsDisabled;
  }

  showField(action: any = 'open'){
    this.launchAction.emit({
      action: action,
      field: this.customizeFields.field
    });
  }

  launchFieldAction(action: any, from: any = 'inside'){
    if(action === 'edit'){
      if(this.typeView === 'channelView'){
        this.launchAction.emit({
          action: 'editField',
          field: this.customizeFields.field
        });
      }else{
        this.editField();
      }
    }else if(action === 'delete'){
      this.typeView !== 'channelView' && this.commonUtilsService.checkCustomizeFieldInFormula(this.customizeFields.field, this.concept.fieldContainers, 'field')? this.modalService.errorModal({ text: this.translate.instant('customize-concept.field-in-formu-message') }) : this.deleteField(from);
    }
  }

  changeEditableField(field: any){
    if(!field.label){
      if (this.typeView !== 'translationsViewEditable') {
        this.customizeFieldInput.nativeElement.focus();
      }
      field.error = true;
    }else{
      field.error = false;
      field.editableName = false;
    }
  }

  openViewTranslationEditable(field: any) {
    field.open = true;
    field.editableName = !field.editableName;
  }

  checkErrorLabel(container: any){
    container.error = container.name?.length?false:container.error;
    this.customizeFields.disabledClick = false;
  }

  openVisibility(e:any){
    this.customizeFields.field.visibilityOr = e.visibilityOr;
  }

  itemSelected(e:any, item:any){
    let that: any = this.customizeFields;
    switch(item){
      case 'isEditable':
        that.field[item] = e.newValue;
        let type: string = that.field.isEditable?'isHighlight':'required';
        that.field[type] = false;
        break;
      case 'documentId':
        if(e.newValue){
          this.customizeFields.fieldTemplates.error = false;
        }
        that.field.documentTemplateId = e.newValue;
        that.field.fieldAttributes[item] = e.newValue;
        break;
      default:
        that.field[item] = e.newValue;
        break;
    }
  }

  editField(){
    let configurationOptions: any = {
      field: this.customizeFields.field,
      fieldContainer: this.fieldContainer,
      concept: this.concept,
      actionType: 'edit',
      visibilityItems: this.visibilityItems
    }
    let configuration: any = this.commonUtilsService.configureFieldEidtable(configurationOptions);
    this.modalService.customizeFieldModal(configuration)
      .subscribe((result:any)=>{
        if(result.result==='ok'){
          result.field.open = this.customizeFields.field.open;
          this.customizeFields.field = result.field;
          this.fieldContainer.fields = this.commonUtilsService.replaceElement(result.field, this.fieldContainer.fields, 'fieldId', result.field);
          this.launchAction.emit({
            action: 'saved',
            field: this.customizeFields.field
          });
        }
      })
  }

  deleteField(from: any){
    this.modalService.infoModal({ text: this.translate.instant('customize-concept.question-delete-field'), typeButtons: 'cancelRemove' })
      .subscribe((result:any)=>{
        if(result.result==='ok'){
          this.loader.openLoader('customize-concept-delete-field')
          this.deletefieldSelected(this.customizeFields.field, from);
        }
      })
  }

  deletefieldSelected(field:any, from: any){
    this.apiService.delete('fields', field.fieldId)
      .then((data:any)=>{
        this.fieldContainer.fields = this.commonUtilsService.deleteElement( field, this.fieldContainer.fields, 'fieldId');
        this.loader.closeLoader(['customize-concept-delete-field']);
        this.modalService.successModal({ text: this.translate.instant('customize-concept.confirmed-delete-field') });
        if(this.typeView === 'channelView' || from === 'modal'){
          this.launchAction.emit({
            action: 'deleted',
            field: field
          });
        }
      }, (errorData:any)=>{
        this.loader.closeError();
        let text: string  = this.translate.instant('customize-concept.error-delete-field');
        if(errorData.status === 403){
          text = this.translate.instant('concept-list.delete-error-permissions');
        }else if(errorData.exceptionMessage==="Field in formula"){
          text = this.translate.instant('customize-concept.field-in-formu-message');
        }
        this.modalService.errorModal({ text: text });
      })
  }

  saveField(){
    let validFieldForm: boolean = this.validateSave();
    if(validFieldForm){
      this.loader.openLoader('customize-save-field');
      if(this.actionType === 'create'){
        this.createNewField(this.customizeFields.field);
      }else{
        this.configureAndSaveField(this.customizeFields.field);
      }
    }else{
      this.modalService.errorModal({ text: this.translate.instant('customize-field.generic-error') });
    }
  }

  validateSave(){
    switch(this.customizeFields.field.fieldTypeId){
      case 'text':
        return this.customizeFieldText.validateSave();
      case 'money':
        return this.customizeFieldMoney.validateSave();
      case 'l-co':
        return this.customizeFieldOther.validateSave();
      case 'boolp':
        return this.customizeFieldBool.validateSave();
      case 'list':
      case 'listp':
        return this.customizeFieldList.validateSave();
      case 'txchk':
        this.customizeFields.descriptionField.error = this.customizeFields.field.description?false:true;
        return !this.customizeFields.descriptionField.error;
      case 'formu':
      case 'formp':
        return this.customizeFieldFormula.validateSave();
      case 'templ':
        this.customizeFields.fieldTemplates.error = this.customizeFields.field.documentTemplateId?false:true;
        return !this.customizeFields.fieldTemplates.error;
      case 'alert':
      case 'task':
      case 'rich':
      case 'num':
      case 'date':
      case 'file':
      case 'user':
      case 'bool':
      default:
        return true;
    }
  }

  createNewField(field: any){
    let newField: any = {
      fieldTypeId: field.fieldTypeId,
      label: field.label,
      name: field.name,
      title: field.title,
      numOrder: this.fieldContainer.fields?.length+2
    }
    delete field.fieldId;
    this.apiService.add('fields/'+this.fieldContainer.fieldContainerId, newField)
      .then((data:any)=>{
        field = Object.assign({}, data, field);
        this.configureAndSaveField(field);
      }, (errorData)=>{
        this.loader.closeError();
      });
  }

  configureAndSaveField(field: any){
    this.commonUtilsService.configureCustomizeFieldAttributes(field);
    this.apiService.patch('fields',field.fieldId, field)
      .then((data:any)=>{
        if (field.fieldTypeId === 'list' || field.fieldTypeId === 'listp'){
          field.listValues = data;
        }
        this.loader.closeLoader('customize-save-field');
        // this.fieldContainer.fields = this.commonUtilsService.replaceElement(field, this.fieldContainer.fields, 'fieldId', field);
        this.modalService.successModal({ text: this.translate.instant('customize-concept.created-field') });
        this.launchAction.emit({
          action: 'saved',
          field: field
        });
      }, (errorData:any)=>{
        this.loader.closeError();
        let text: string = this.translate.instant('customize-concept.delete-error');
        if(errorData.description === 'IdentifierFieldAlreadyExists'){
          text = this.translate.instant('customize-concept.delete-error-exist');
        }else if(errorData.description.indexOf('IsManagerClassificator') !== -1){
          text = this.translate.instant('customize-field-list.manager-classificator-error');
        }
        this.modalService.errorModal({ text: text });
      })
  }
}
